__turbopack_context__.v({
  "container": "co9Edq_container",
  "svg": "co9Edq_svg",
});
